/**
 * @file Remove after full transition on Tag manager by all licensees
 */
import { pick } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pickPaths } from 'js/utils/methods.util';
import { evalJavaScript } from 'js/utils/DOM.util';
import { useAppSelector, usePageSelector } from 'js/store/hooks';
import { toggleIsAppInitExecuted } from 'js/components/system/App/store/actions';

export const useCodeInsertions = () => {
    const {
        isPageRendering,
        isPageRendered
    } = usePageSelector(pick(['isPageRendering', 'isPageRendered']));
    const { isAppInitExecuted } = useAppSelector(pick(['isAppInitExecuted']));
    const dispatch = useDispatch();
    const {
        onAppInit,
        onPageRendering,
        onPageRendered
    } = useAppSelector(pickPaths([
        ['codeInsertion', 'onAppInit'],
        ['codeInsertion', 'onPageRendering'],
        ['codeInsertion', 'onPageRendered']
    ]));

    useEffect(() => {
        if (onAppInit && !isAppInitExecuted) {
            evalJavaScript({
                code: onAppInit,
                context: 'codeInsertion::onAppInit'
            });
            dispatch(toggleIsAppInitExecuted(true));
        }
    }, [onAppInit, isAppInitExecuted, dispatch]);

    useEffect(() => {
        if (onPageRendering && isPageRendering) {
            evalJavaScript({
                code: onPageRendering,
                context: 'codeInsertion::onPageRendering'
            });
        }
    }, [onPageRendering, isPageRendering]);

    useEffect(() => {
        if (onPageRendered && isPageRendered) {
            evalJavaScript({
                code: onPageRendered,
                context: 'codeInsertion::onPageRendered'
            });
        }
    }, [onPageRendered, isPageRendered]);
};
